import moduleMaterialTypeService from '../services/moduleMaterialType.service'

const state = {
  all: {
    items: {}
  }
}

const actions = {
  getAll ({ commit }, { module }) {
    commit('getAllRequest')
    moduleMaterialTypeService.getAll({ module })
      .then(
        materialTypes => commit('getAllSuccess', { materialTypes }),
        error => commit('getAllFailure', error)
      )
  }
}

const mutations = {
  getAllRequest (state) {
    state.all = { ...state.all, loading: true }
  },
  getAllSuccess (state, { materialTypes }) {
    state.all = { ...state.all, items: materialTypes }
  },
  getAllFailure (state, error) {
    state.all = { ...state.all, error }
  }
}

export const moduleMaterialTypes = {
  namespaced: true,
  state,
  actions,
  mutations
}
